export default "__VITE_ASSET__BXD3JF$a__"